// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"199":"views","282":"views-app","768":"App","914":"views-error"}[chunkId] || chunkId) + "." + {"19":"48914798","199":"ddd9e45d","282":"d6c1bd30","521":"69e96166","538":"7e6c59fe","711":"d5488b04","746":"81de4a2b","768":"d9b3f08e","914":"16349be9"}[chunkId] + ".chunk.js";
};